exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".variation-chip[data-v-c380e56c]{display:inline-flex;align-items:center;gap:4px;font-size:.78rem;font-weight:700;background:#ffffff7a;border-radius:5px;padding:3px 8px;white-space:nowrap;min-width:0}.variation-chip-icon[data-v-c380e56c]{flex:none}.variation-chip.up[data-v-c380e56c]{color:#0cc100}.variation-chip.down[data-v-c380e56c]{color:#c10000}.variation-chip.stable[data-v-c380e56c]{color:#7a7a7a}.variation-chip-value[data-v-c380e56c]{min-width:34px;text-align:right}.variation-chip-note[data-v-c380e56c]{font-weight:500;opacity:.8;overflow:hidden;text-overflow:ellipsis;min-width:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c380e56c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/climan/components/variationChip.vue
// module id = 1373
// module chunks = 2